export const Footer = () => {
  const currentDate = new Date();
  const fullYear = currentDate.getFullYear();
  return (
    <footer>
      <p>
        © Permobil&nbsp;
        <span>{fullYear}</span>. All rights reserved.&nbsp;
        <a
          href="https://www.permobil.com/privacy-notice/speedcontroldialrecallpermobilcom"
          target="_blank"
          rel="noreferrer"
        >
          Permobil Privacy Information
        </a>
      </p>
    </footer>
  );
};
